<template>
  <div style="position:relative">
    <div class="location_css">
      <img src="../../assets/img/location.png">
      <div>当前位置：</div>
      <div @click="goSy()">首页</div>
      <div> <i class="el-icon-arrow-right"></i> </div>
      <div class="location_text">产业地图</div>
    </div>
    <div id="container" style="height:550px;margin-top:10px;margin-bottom:10px"></div>
    <div class="company-main">
      <el-tabs v-model="activeName" @tab-click="tabChange">
        <el-tab-pane v-loading="loading" v-for="(item, index) in tabList" :key="index" :label="item.name"
          :name="item.value">
          <div class="main-item" v-for="(item, index) in list" :key="index" @click="view(item)" style="cursor:pointer;">
            <div class="company-name" style="display:flex">
              <img v-if="activeName == 'first'" style="width:25px;margin-right:5px;height:25px"
                :src="'http://fxhjzx.cn/fxWeb/' + (index + 1) + 's.png'" alt="">
              <img v-else style="width:25px;margin-right:5px;height:25px" :src="(index + 1) + '.png'" alt="">
              <div>{{ item.name }}</div>
            </div>
            <!-- <div class="company-address">地址：{{ item.address }}</div> -->
          </div>
        </el-tab-pane>
        <!-- <el-tab-pane label="生产企业" name="first">
      <div class="main-item" v-for="(item,index) in mapList" :key="index" @click="view(item)" style="cursor:pointer;">
         <div class="company-name" style="display:flex">
           <img style="width:25px;margin-right:5px" :src="(index + 1) + '.png'" alt="">
           <div>{{item.name}}</div>
          </div>
         <div class="company-address">地址：{{item.address}}</div>
      </div>
    </el-tab-pane>
    <el-tab-pane label="销售网点" name="second">
      <div class="main-item" v-for="(item,index) in saleList" :key="index" @click="view(item)" style="cursor:pointer;">
         <div class="company-name" style="display:flex">
           <div>{{item.name}}</div>
          </div>
         <div class="company-address">地址：{{item.address}}</div>
      </div>
    </el-tab-pane> -->
      </el-tabs>

    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [],
      loading: false,
      tabList: [{ name: "生产企业", value: "first" }, { name: "销售网点", value: "second" }],
      saleList: [{ name: "销售网点一", address: "湖北省十堰市" }, { name: "销售网点二", address: "湖北省十堰市" }],
      activeName: "first",
      markers: [],
      map: ""
    }
  },
  computed: {
    // mapList(){
    //   return config.mapConfigList
    // }
  },
  methods: {
    getList(url, params) {
      return new Promise((resolve, reject) => {
        this.$axios.get(url, { params: params }).then(resp => {
          if (resp.errcode == 0 || resp.errcode == "0" || resp.status == 0 || resp.status == "0") {
            this.list = resp.data.dataList.map((item, index) => ({
              index: index,
              name: item.name,
              address: item.address,
              latitude: item.latitude,
              longitude: item.longitude
            }));
            resolve("success")
          } else {
            resolve("error")
          };
        });
      }, () => {
        resolve("error")
      });
    },
    async tabChange(data) {
      this.markers = [];
      this.loading = true;
      let _this = this;
      let result = "";
      if (data.value == "first" || data.name == "first") {
        result = await this.getList("oasis/em-entity/pager", { typeId: "006", pageNum: 1, pageSize: 1000 });
      } else {
        result = await this.getList("fx-web/wine/commercialNetwork/pager", { typeId: "006", pageNum: 1, pageSize: 1000 });
      };
      console.log(_this.list, '666');
      if (result == "success") {
        let _this = this;
        let map = new AMap.Map("container", { resizeEnable: true, zoom: 6 });
        this.list.forEach((item, index) => {
          if (item.latitude && item.longitude) {
            let icon = ''
            if (_this.activeName == 'first') {
              icon = new AMap.Icon({
                image: "http://fxhjzx.cn/fxWeb/" + (item.index + 1) + "s.png",
                size: new AMap.Size(50, 60),

              });
            } else {
              icon = new AMap.Icon({
                image: (item.index + 1) + ".png",
                size: new AMap.Size(50, 60),

              });
            }

            let marker = new AMap.Marker({
              icon: icon,
              position: [item.latitude, item.longitude],//纬度经度
              offset: new AMap.Pixel(-12, -12),
              zIndex: 101,
              title: item.name,
              map: map,
            });
            AMap.event.addListener(marker, 'click', function () {
              _this.markers.forEach((m, i) => {
                if (i == item.index) {
                  m.setIcon(
                    new AMap.Icon({
                      image: "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png",
                      size: new AMap.Size(50, 60),
                    }));
                } else {
                  if (_this.activeName == 'first') {

                    m.setIcon(new AMap.Icon({
                      image: "http://fxhjzx.cn/fxWeb/" + (i + 1) + "s.png",
                      size: new AMap.Size(50, 60),
                    }));

                  } else {
                    m.setIcon(new AMap.Icon({
                      image: (i + 1) + ".png",
                      size: new AMap.Size(50, 60),
                    }));
                  }
                  // m.setIcon(new AMap.Icon({
                  //   image: (i + 1) + ".png",
                  //   size: new AMap.Size(50, 60),
                  // }));
                };
              });
              new AMap.InfoWindow({
                anchor: 'bottom-center',
                content: item.name,
                offset: new AMap.Pixel(10, -15)
              }).open(map, marker.getPosition());
            });
            this.markers.push(marker);
          };
        });
        map.setFitView();
        this.map = map;
      };
      this.loading = false;
    },


    view(data) {
      if (!data.longitude || !data.latitude) {
        this.$message({
          message: "该数据没有经纬度信息，请在后台添加",
          type: 'warning'
        });
        return;
      };
      AMap.event.trigger(this.markers[data.index], "click");
      this.map.panTo([data.latitude, data.longitude]);
    },
    goSy() {
      this.$router.push({
        path: "/home"
      });
    }
  },
  mounted() {
    this.tabChange(this.tabList[0]);

  },
};
</script>
<style scoped lang="scss">
::v-deep {
  .el-tabs__item {
    color: #D92208 !important;
  }

  .el-tabs__active-bar {
    background-color: #D92208 !important;
  }

  .amap-icon img {
    width: 45px !important;
  }

  .amap-info-content {
    color: #035AB1;
  }

  .company-main {
    top: 60px;
    width: 250px;
    height: 400px;
    background-color: rgba(255, 255, 255, 0.4);
    
    position: absolute;
    z-index: 1000;
    right: 5px;
    padding: 12px;
    overflow: auto;

    .main-item {
      padding-top: 5px;
      padding-bottom: 5px;
      line-height: 25px;
    }

    .company-name {
      color: #035AB1;
      font-size: 14px;
    }

    .company-address {
      color: #999999;
      font-size: 13px;
    }
  }
}
</style>
